export default {
  SET_ACCOUNT_STATUS_TREND_LIST(state, params) {
    state.accountStatusTrendList = params;
  },
  SET_ACCOUNT_STATUS_DIFF_LIST(state, params) {
    state.accountStatusDiffList = params;
  },
  SET_ACCOUNT_STATUS_CSP_LIST(state, params) {
    state.accountStatusCspList = params;
  },
}



// WEBPACK FOOTER //
// ./src/vuex/monitoring/cloudaccount/status/accountStatusMutation.js